import { css } from '../../styled-system/css';
import {
  discoveryTableHeader,
  discoveryTableHeading,
  discoveryTableCell,
  discoveryTableMobileCell,
} from '@/discovery/tableStyles';

const columns = 'minmax(0, 1fr) minmax(100px, 190px) 64px';
const mobileColumns = 'minmax(0, 1fr) 108px 64px';
export const projectListStyles = {
  header: css({
    ...discoveryTableHeader,
    // Stay above the overlaid row menu controls while the page scrolls.
    zIndex: 2,
    display: 'grid',
    gridTemplateColumns: columns,
    '& > span': discoveryTableHeading,
    '& > span:last-child': { textAlign: 'right' },
    '@media (max-width: 600px)': {
      gridTemplateColumns: mobileColumns,
      '& > span': discoveryTableMobileCell,
    },
  }),
  link: css({
    display: 'grid',
    gridTemplateColumns: columns,
    alignItems: 'center',
    '& > span, & > time': { padding: discoveryTableCell.padding },
    '@media (max-width: 600px)': {
      gridTemplateColumns: mobileColumns,
      '& > span, & > time': discoveryTableMobileCell,
    },
  }),
  date: css({ color: '#b6c0cd', fontSize: '13px', overflowWrap: 'anywhere' }),
};
